<template>
  <div id="bm-team-manage-list" >
    <!--<div v-if="passTeams" >
      <div class="main" v-if="!passTeams.length" >
        <div class="title" >暂无参赛球队！</div>
        <p>快去召集球队吧</p>
      </div>
      <div class="main" v-if="passTeams.length" >
        <div class="title" >
          参赛球队
          <span>{{ passTeams.length }}</span>
        </div>
        <div class="player" @click="teamInfo(item.teamId)" v-for="item in passTeams" :key="item.id" >
          <div>
            <img :src="formatterImgSrc(item.teamBadge)">
          </div>
          <div>
            <p>{{ item.teamName }}</p>
            <span>{{ item.playerCount }}人</span>
          </div>
        </div>
        <div style="width: 100%; height: 50px;" ></div>
      </div>
      <div class="foot" v-if="matchId" @click="share()" >
        <a>
          邀请球队完善资料
        </a>
      </div>
    </div>-->

    <div v-if="matchType === 'league'" >
      <div class="main" v-if="groups.length" >
        <div class="title" >
          参赛球队
          <span>{{ groupsLength }}支</span>
        </div>
        <div class="player-block" v-for="item in groups[0].teams" :key="item.id" @click="teamInfo(item.id)" >
          <div>
            <img :src="formatterImgSrc(item.badge)">
          </div>
          <div>
            <p>{{ item.name }}</p>
            <span>{{ item.memberCount }}人</span>
          </div>
        </div>
        <div style="width: 100%; height: 50px;" ></div>
      </div>
    </div>

    <div v-if="matchType === 'cup'" >
      <div class="main" v-if="groups.length" >
        <div class="title" >
          参赛球队
          <span>{{ groupsLength }}支</span>
        </div>
        <div v-for="(item, index) in groups" :key="index">
          <div class="group-name" >{{ item.name ? item.name : '待分组' }}</div>
          <div class="player-block" v-for="teams in item.teams" :key="teams.id" @click="teamInfo(teams.id)" >
            <div>
              <img :src="formatterImgSrc(teams.badge)">
            </div>
            <div class="info">
              <p>{{ teams.name }}</p>
              <span>{{ teams.memberCount }}人</span>
            </div>
            <div class="not-group" v-if="item.name == ''" @click.stop="setGroup(teams.id)" >未分组</div>
          </div>
        </div>
        <div style="width: 100%; height: 50px;" ></div>
      </div>
    </div>

    <div class="foot" v-if="matchId" @click="share()" >
      <a>
        邀请球队完善资料
      </a>
    </div>

    <!-- 引导页弹窗 -->

    <van-popup class="guidePopup" v-model="isShowGuidePopup">
      <img src="@/assets/images/guide.png">
    </van-popup>

    <!-- 分组 -->
    <van-popup
      v-model="setGroupShow"
      position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="name"
        @cancel="onCancel"
        @confirm="onConfirm">
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { ImageFormat, AppType } from '@/utils/'
import { getBMMatchGroupTeam, updateBMMatchTeam, getBMMatchTeams } from '@/api/team'
import { callShare } from '@/libs/ds-bridge'
import { Cell, CellGroup, Button, Row, Col, Toast, Popup, Picker } from 'vant'
Vue.use(Cell).use(CellGroup).use(Button).use(Row).use(Col).use(Toast).use(Popup).use(Picker)
export default {
  name: 'TeamList',
  data() {
    return {
      query: this.$route.query,
      matchId: null,
      passTeams: [],
      isShowGuidePopup: false,
      data: null,
      shareData: {},
      groups: [],
      matchType: null,
      match: null,
      teamId: null,
      setGroupShow: false,
      columns: []
    }
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 104, 104)
      }
    },
    groupsLength() {
      let length = 0
      this.groups.filter(item => {
        length += item.teams.length
      })
      return length
    }
  },
  created() {
    this.matchId = this.query.matchId
    if (!this.matchId) {
      Toast.loading({
        mask: true,
        message: '参数错误',
        duration: 0
      })
      return
    }
    this.popupLoading.loading()
    this.getBMMatchTeams()
    this.getBMMatchGroupTeam()
  },
  methods: {
    teamInfo: function(teamId) {
      this.$router.push({
        path: '/participate/team-info',
        query: {
          teamId: teamId,
          matchId: this.matchId
        }
      })
    },
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      return arr[0] + 'index.html#/invite-team-edit?matchId=' + this.matchId
    },
    getBMMatchTeams() {
      getBMMatchTeams({ matchId: this.matchId }).then((response) => {
        let data = this.data = response.data
        this.columns = data.match && data.match.groups
        let url = this.getShareLink()
        this.shareData = {
          title: '参赛球队资料收集',
          link: url,
          image: ImageFormat.squareImageView(data.match.icon, 120),
          abstract: data.match.chineseName
        }
        this.wxShare(this.shareData)
      })
    },
    share() {
      let url = this.getShareLink()
      let share = {
        title: '参赛球队资料收集',
        desc: this.match.chineseName,
        link: url,
        imgUrl: ImageFormat.squareImageView(this.match.icon, 120)
      }
      if (AppType.isInApp()) {
        callShare(share)
      } else {
        this.isShowGuidePopup = true
      }
    },
    getBMMatchGroupTeam() {
      getBMMatchGroupTeam({ matchId: this.matchId }).then(response => {
        const data = response.data
        this.match = data.match
        this.groups = data.groups
        this.matchType = data.match.type
        this.popupLoading.clear()
      })
    },
    setGroup(id) {
      this.teamId = id
      this.setGroupShow = true
      return false
    },
    onConfirm(group) {
      let params = {
        matchId: this.matchId,
        teamId: this.teamId
      }
      if (group && group.id) {
        params.groupId = group.id
      }
      updateBMMatchTeam(params).then(response => {
        this.setGroupShow = false
        if (response) {
          this.getBMMatchGroupTeam()
        }
      })
    },
    onCancel() {
      this.setGroupShow = false
    }
  }
}
</script>

<style lang="stylus" >
#bm-team-manage-list
  height 100%
  overflow-y scroll
  .group-name
    background-color #F8F8F8
    padding: 10px
    font-size:16px;
    font-weight:400;
    color:rgba(138,138,138,1);
  .title
    font-size: 30px;
    font-weight: 400;
    color: rgba(0,0,0,1);
    padding: 10px 15px;
    span
      text-align right
      float right
  .title+p
    font-size:16px;
    font-weight:300;
    color:rgba(0,0,0,1);
    padding: 0 15px
    margin-top 0
  .player-block
    display flex
    padding 15px
    width calc(100% - 30px)
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
    .info
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 110px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
      span
        font-size:12px;
        font-weight:400;
        color:rgba(129,129,129,1);
    .not-group
      font-size:16px;
      font-weight:400;
      color:rgba(50,163,119,1);
      line-height 52px;
  .foot
    padding: 10px 0
    background: rgba(250,250,250,1);
    color: #32A377
    font-size 20px
    text-align center
    position fixed
    bottom: 0
    width: 100%
    max-width 480px
    a
      color: #32A377
      font-size: 20px
  .guidePopup
    background-color transparent
    width calc(100% - 100px)
    top: 0px
    max-width 480px
    transform: translate3d(-50%,0%,0);
    img
      width 100%
</style>



// WEBPACK FOOTER //
// src/pages/team/participate/team-list.vue